import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap';

import { BaseModalComponent, ConfirmationModalComponent } from './shared/common/modals/index';

import { UtilsModule } from '../shared/utils/utils.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ModalModule.forRoot(),

        UtilsModule,
    ],
    declarations: [
        BaseModalComponent,
        ConfirmationModalComponent
    ],
    exports: [
        BaseModalComponent,
        ConfirmationModalComponent
    ],
})
export class AxillaAppSharedModule {
    static forRoot(): ModuleWithProviders<CommonModule> {
        return {
            ngModule: CommonModule,
        };
    }
}
